import React, {useEffect, useRef, useState} from "react";
import Navbar from "../nav/Navbar";
import Carousel from 'react-bootstrap/Carousel';
import {useNavigate, useParams} from "react-router-dom";
import "./photos.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import {useDispatch, useSelector} from "react-redux";

import {
    getImageTypeView,
    getPrimaryandSecondaryVehicles,
    getProfileView,
    getTrimModels,
    searchMakeCodes,
    VehicleIndex,
    setCompareImages,
    setImageTypeView,
    setProfileView,
    setSecondariesMake,
    secondaryYears,
    secondarySearch,
    searchMake,
    fetchTrimData,
    secondaryVehiclesTrims,
    clearCompareData,
    exterirorColorCode,
    getVehicleTypesName,
    getVehicleTypes,
    setCheckedFeature,
    setAdvantagesCheck,
    getFeatuerSearch,
    isExpandedArr,
    isOpen,
    setRemovedVehicle,
    setImageType,
    clearPhotoStates,
    resetFilterButtons,
    getClientprofile,
    setActiveLanguage,
    postCompareImages,
    setActiveLocale,
    isFetureNavigate,
    setColorIcon,
    setCompareDataGroupInfo,
    getSegmentsByFilter,
    defaultMinPrice,
    defaultMaxPrice,
    getSelectedPriceRange,
    storeLockedVehicles,
    storeLockedCompetitors,
    setCategories,
    setSecondaryYears,
    isLoading,
    getVehicleCode,
    setVehicleCode,
    setVehicleIndex,
    getSecondaryVehicleIndex,
    getCarouselIndex,
    setCarouselIndex,
    getVehicleIndex,
    setErrorCode,
    setCompareGroupData,
    getCarouselVehicleIndex,
    hasAngleChanged,
    setIsAngleChanged,
    getPrimaryCarouselVehicleIndex, isSwappedTriggered, swapCompareImages, setHeaderLoadType
} from "../../slices/vehicleSlice";
import {Color} from "../compare/Color";
import CloseIcon from "@mui/icons-material/Close";
import comingSoonIMG from '../../images/image_coming_soon-min.png';
import {Change} from "../compare/Change";
import {Modal} from "@mui/material";
import MediaQuery, {useMediaQuery} from "react-responsive";
import {getKeyByValue} from "../compare/change.method";
import {useTranslation} from "react-i18next";
import {NavbarBtn} from "../nav/NavbarBtn";
import {getActiveLanguage} from "../vehicle/vehicle.utility";
import {checkLockStatus, handleChangeModalClose, showMobileNav, toggleLockStatus} from "../compare/compare.method";
import {
    trackEnlargeViewHandler,
    trackGalleryViewSelected,
    trackInteriorFilterButton,
    trackExteriorFilterButton,
    trackNavigateToNewCompare, trackRemovedVehicle, trackViewGallery, trackGalleryScrollRight, trackGalleryScrollLeft
} from "../GoogleTagManager.utils";
import comingSoonIMG_fr from "../../images/image_coming_soon-fr-min.png";
import comingSoonIMG_es from "../../images/image_coming_soon-es-min.png";
import LockCompetitor from "../Button/LockCompetitor";
import Loader from "../Loader/Loader";
import VehicleDetailsLargeScreen from "./VehicleDetailsLargeScreen";
import {currencyConverter} from "../../utility/methods";
import {getVehicleDetails, handleModalClose, initiateSwapCompetitor} from "./photos.utils";
import SecondaryVehicleCarousel from "./SecondaryVehicleCarousel";
import PrimaryVehicleDetails from "./PrimaryVehicleDetails";
import PrimaryVehicle from "./PrimaryVehicle";
import PhotoViewFilter from "./PhotoViewFilter";
import PrimaryVehicleToolbar from "./PrimaryVehicleToolbar";
import PrimaryVehicleEnlarge from "./PrimaryVehicleEnlarge";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUpRightAndDownLeftFromCenter} from "@fortawesome/free-solid-svg-icons";
import SecondaryCompetitors from "./SecondaryCompetitors";
import BuildMissingCompetitor from "./BuildMissingCompetitor";
import PowerTrainType from "../Button/PowerTrainType";

const Photos = (props) => {
    const navigate = useNavigate();
    const currentUrl = window.location.pathname;
    const {t} = useTranslation();
    const dispatch = useDispatch();
    let {code} = useParams();

    const removeVehicle = (vehicle, id) => {
        dispatch(setRemovedVehicle({code: vehicle.code, id: id}))
        trackRemovedVehicle(compareGroup)
    };

    const viewAngle = useSelector(getImageTypeView)
    const {pathname} = window.location;
    const profile = useSelector(getProfileView);
    const trimCodes = useSelector(secondaryVehiclesTrims)
    const activeLocale = useSelector(setActiveLocale)
    const setPrimaryAndSecondaryVehicles = useSelector(getPrimaryandSecondaryVehicles);
    const getCompareImages = useSelector(setCompareImages)
    const secondaryYear = useSelector(setSecondaryYears);
    const vehiclesMakes = useSelector(setSecondariesMake);
    const vehicleModels = useSelector(searchMakeCodes);
    const vehiclesTrim = useSelector(getTrimModels);
    const vehicleIndex = useSelector(VehicleIndex);
    const colorCode = useSelector(exterirorColorCode)
    const min = useSelector(defaultMinPrice)
    const max = useSelector(defaultMaxPrice)
    const vehicleTypeName = useSelector(getVehicleTypesName);
    const vehicleTypes = useSelector(getVehicleTypes)
    const isCategoryOpen = useSelector(isOpen)
    const compareGroup = useSelector(setCompareDataGroupInfo)
    const vehicleCode = useSelector(getVehicleCode)
    const secondaryCarouselIndex = useSelector(getCarouselVehicleIndex)
    const isPrimaryImageCarousel = useSelector(getPrimaryCarouselVehicleIndex)
    const secondaryVehicleIndex = useSelector(getSecondaryVehicleIndex)
    const secondaryIndex = useSelector(getCarouselIndex)
    const errorCode = useSelector(setErrorCode)
    const headerLoadType = useSelector(setHeaderLoadType);
    const [open, setOpen] = React.useState(false)
    const [openEnlarge, setOpenEnlarge] = React.useState(false)
    const [secondaryLarge, openSecondaryEnlarge] = React.useState(false)
    const [activeButton, setActiveButton] = React.useState(null)
    const [loading, setLoading] = React.useState(true);
    const [vehicleData, setVehicleData] = React.useState(null);
    const [vehicleDescription, setVehicleDescription] = React.useState(null)
    const [openModal, setOpenModal] = React.useState(false);
    const [trimModel, setTrimModel] = React.useState('')
    const [vehicleModel, setVehicleModel] = React.useState('')
    const [buttonClicked, setButtonClicked] = React.useState(false);
    const [scroll, setScroll] = React.useState(0);
    const [isTop, setIsTop] = React.useState(true);
    const [driveType, setDriveType] = React.useState("")
    const [vehicleMake, setVehicleMake] = React.useState("");
    const [isButtonClicked, setIsButtonClicked] = React.useState(false);
    const [showNav, setShowNav] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const [loadingStates, setLoadingStates] = useState({});
    const timerRefs = useRef({});
    const isLoaded = useSelector(isLoading);
    const isLocked = useSelector(storeLockedCompetitors);
    const isAngleChanged = useSelector(hasAngleChanged)
    const isMobile = useMediaQuery({query: '(max-width: 479px)'})
    const maxSmallScreenWidth = useMediaQuery({query: '(max-width: 899px)'})
    const isMobileHeight = useMediaQuery({query: '(max-height: 479px)'})
    const swapTriggered = useSelector(isSwappedTriggered)
    const vehicleCTA = getCompareImages && "https://www.jdpower.com/cars-for-sale/make-"+ getCompareImages[0]?.make.toLowerCase().replace(/ /g, "-") + "/model-" + getCompareImages[0]?.model.toLowerCase().replace(/ /g, "-")

    useEffect(() => {
        if (Object.keys(isLocked).length > 0) {
            sessionStorage.setItem("lockedInfo", JSON.stringify(isLocked));
        }
    }, [isLocked]);

    useEffect(() => {
        getCompareImages && getCompareImages[0] && dispatch((setCompareGroupData({
            primaryVehicleDescription: getCompareImages[0]?.description,
            secondaryOneVehicleDescription: getCompareImages[1] ? getCompareImages[1].description : null,
            secondaryTwoVehicleDescription: getCompareImages[2] ? getCompareImages[2].description : null,
            secondaryThreeVehicleDescription: getCompareImages[3] ? getCompareImages[3].description : null,
            primaryVehicleMSRP: getCompareImages[0]?.pricing.msrp,
            secondaryOneVehicleMSRP: getCompareImages[1] ? getCompareImages[1].pricing.msrp : null,
            secondaryTwoVehicleMSRP: getCompareImages[2] ? getCompareImages[2].pricing.msrp : null,
            secondaryThreeVehicleMSRP: getCompareImages[3] && getCompareImages[3] && getCompareImages[2]
                ? getCompareImages[2].pricing.msrp
                : null,
            primaryVehicleYear: getCompareImages[0]?.year,
            primaryVehicleTrim: getCompareImages[0]?.trim,
            primaryVehicleMake: getCompareImages[0]?.make,
            primaryVehicleModel: getCompareImages[0]?.model,
            errorCode: errorCode
        })))
    }, [getCompareImages,activeLocale])

    useEffect(() => {
        return () => {
            Object.values(timerRefs.current).forEach(timer => {
                if (timer) {
                    clearTimeout(timer);
                }
            });
        };
    }, []);

    const handleClick = (id, dispatch, isMobile, isMobileHeight) => {
        if (isMobile || isMobileHeight) {
            if (timerRefs.current[id]) {
                clearTimeout(timerRefs.current[id]);
            }
            setLoadingStates(prevState => ({ ...prevState, [id]: true }));
            initiateSwapCompetitor(id, dispatch);
            timerRefs.current[id] = setTimeout(() => {
                setLoadingStates(prevState => ({ ...prevState, [id]: false }));
                timerRefs.current[id] = null;
            }, 1000);
        }
    };

    const handleToggle = (index, vehicle) => {
        toggleLockStatus(index, vehicle, isLocked, dispatch, storeLockedVehicles, compareGroup);
    };

    const navigateFeatures = () => {
        dispatch(isExpandedArr(isCategoryOpen))
        dispatch(resetFilterButtons("EXTERIOR"))
        dispatch(setImageType("EXTERIOR"))
        dispatch(setProfileView("FRONT_3QTR_LEFT"))
        dispatch(setCarouselIndex(0))
        dispatch(setVehicleIndex(0))
        dispatch(setVehicleCode(0))
        dispatch(swapCompareImages({ swapTriggered: false }));
        sessionStorage.removeItem('compareImages')

        let primaryVehicle = code;
        let secondaryVehicles = [];

        if (trimCodes && Array.isArray(trimCodes) && trimCodes.length > 0) {
            const normalizedTrimCodes = trimCodes.filter((value) => value !== undefined);

            if (normalizedTrimCodes.length > 0 && normalizedTrimCodes[0] === code) {
                secondaryVehicles = normalizedTrimCodes.slice(1);
            } else if (normalizedTrimCodes.length > 0 && normalizedTrimCodes[0] !== code) {
                primaryVehicle = normalizedTrimCodes[0];
                secondaryVehicles = normalizedTrimCodes.slice(1);
            }
        }
        else if (props.code) {
            const fallbackCodes = String(props.code)
                .split('-')
                .map((value) => value.trim())
                .filter(Boolean);

            if (fallbackCodes.length > 0) {
                primaryVehicle = fallbackCodes[0];
                secondaryVehicles = fallbackCodes.slice(1);
            }
        }

        const trimCodesStr = secondaryVehicles.join('-');

        let countryPath = '';
        if (props.country) {
            countryPath = props.country + '/';
        }
        if (props.language !== 'en') {
            countryPath = countryPath + props.language + '/';
        }
        dispatch(clearCompareData());

        (getCompareImages?.length === 1) ?
            sessionStorage.setItem("competitorsRemoved", "true")
            : sessionStorage.removeItem("competitorsRemoved");

        let url = `/${props.client}/${countryPath}compare/features/${primaryVehicle}/${trimCodesStr}`;
        if (props.client === 'jdpa') {
            url = `/cars/compare-cars/${countryPath}compare/features/${primaryVehicle}/${trimCodesStr}/`;
        }
        navigate(url, {replace: true});
        return () => {

            if (!currentUrl.includes('features')) {
                dispatch(clearCompareData());
            }
        }
    }

    const vehicle = () => {
        dispatch(setColorIcon(null))
        const country = props.country ? `/${props.country}` : '';
        const lng = props.language === 'en' ? '' : `/${props.language}`
        dispatch(clearCompareData())
        dispatch(storeLockedVehicles(null))
        dispatch(resetFilterButtons("EXTERIOR"))
        setIsButtonClicked(true)
        dispatch(setCheckedFeature());
        dispatch(setAdvantagesCheck(true))
        dispatch(setAdvantagesCheck());
        dispatch(setCategories({ removeAll: true }))
        dispatch(getFeatuerSearch(null));
        dispatch(clearPhotoStates())
        dispatch(clearPhotoStates(null))
        dispatch(setImageType("EXTERIOR"))
        dispatch(setCarouselIndex(0))
        dispatch(setVehicleIndex(0))
        dispatch(setVehicleCode(0))
        sessionStorage.removeItem("isTrimSelected");
        dispatch(swapCompareImages({ swapTriggered: false }));
        !!min && !!max && dispatch(getSelectedPriceRange([min, max]));
        dispatch(getSegmentsByFilter({clearData:true}))
        dispatch(setProfileView("FRONT_3QTR_LEFT"))
        navigate(`/${props.client}${country}${lng}/vehicle/`);
        trackNavigateToNewCompare(compareGroup)
        sessionStorage.removeItem('loadPrimaryOnReload');
        sessionStorage.removeItem("competitorsRemoved");
    }

    function hasPrimaryImage(getCompareImages) {
        if (getCompareImages[0] && !!getCompareImages[0].media[Object.keys(getCompareImages[0].media)[0]].length){
            return true
        }
    }

    const enlargeView = () => {
        hasPrimaryImage(getCompareImages) && setOpenEnlarge(true)
        trackEnlargeViewHandler(compareGroup)
    }

    const secondaryEnlargeView = (id,vehicle) => {
        setVehicleDescription(vehicle.description)
        setActiveButton(id)
        hasPrimaryImage(getCompareImages) && openSecondaryEnlarge(true)
        trackEnlargeViewHandler(compareGroup)
    }
    const handleOpen = () => {
        setOpen(true)
        trackViewGallery(compareGroup)
    }
    const handleClose = () => {
        setOpenEnlarge(false)
        setActiveButton(null)
        openSecondaryEnlarge(false)
        setVehicleDescription(null)
        secondaryLarge && dispatch(setCarouselIndex(secondaryVehicleIndex));
        setOpen(false)
    }

    const changeHandler = async (id, vehicle) => {
        if (vehicle?.length === 0) {
            setVehicleMake(null);
            setDriveType(null);
            setVehicleModel(null);
            setTrimModel(null);
        }
        setButtonClicked(true)
        await setVehicleData(vehicle)
        dispatch(getVehicleIndex(id));
        await setOpenModal(true);
    };

    const loadPhotosData = async (props, data,trimCodes,code, codes ) => {
        if (props.codes !== null) {
            codes = [{ code: code }];
        }
        if (props.codes) {
            codes = [{ code: code }];
            const codesArray = props.codes.split('-');
            codesArray.forEach((code) => {
                codes.push({
                    code: code,
                });
            });
        }

        data = {
            exterior: colorCode ? colorCode : null,
            code: codes
        }

            const result = await dispatch(getClientprofile(props));
            if (!result.payload) return;
            const { akanaAppId, profileKey, supportedLanguages } = result.payload;
            dispatch(postCompareImages(data, { akanaAppId, profileKey }));
            const LOCALE = getActiveLanguage(props.language, supportedLanguages);
            dispatch(setActiveLanguage(LOCALE));
    };

    useEffect(() => {
        setVehicleMake(vehiclesMakes)
    }, [vehiclesMakes]);

    useEffect(() => {
        setVehicleModel(vehicleModels)
    }, [vehicleModels])

    useEffect(() => {
        setTrimModel(vehiclesTrim)
    }, [vehiclesTrim])

    useEffect(() => {
        setDriveType(vehicleTypes)
    }, [vehicleTypes])

    useEffect(() => {
        if (window.location.pathname.includes('/us/')) {
            const newUrl = window.location.pathname.replace('/us/', '/');
            window.history.replaceState({}, '', newUrl);
        }
    }, []);

    function handlePhotosDataLoad({ isReload = false }) {
        let data = {};
        let codes = [];
        if (isReload && sessionStorage.getItem('isReload') !== 'true') return;

        if (code) {
            loadPhotosData(props, data, trimCodes, code, codes);
        }

        if (isReload) {
            sessionStorage.removeItem("competitorsRemoved");
            sessionStorage.removeItem('isReload');
        }
    }

    useEffect(() => {
        handlePhotosDataLoad({ isReload: true });
    }, []);

    useEffect(() => {
        handlePhotosDataLoad({ isReload: false });
    }, [code, props.language, activeLocale, props.client]);

    useEffect(()=> {
        const Photo = window.location.pathname.includes('photos')
        dispatch(isFetureNavigate({Photo:Photo}))
    },[getCompareImages])

    useEffect( () => {
        if (getCompareImages && isButtonClicked && getCompareImages[0].media) {
            selectSliderImage(0);
            setIsButtonClicked(false)
        }
    }, [isButtonClicked]);

    useEffect(() => {
        dispatch(setImageType("EXTERIOR"))
    }, [])

    useEffect(() => {
        async function dispatchActions() {
            if (buttonClicked) {
                await dispatch(secondaryYears());
                if (vehicleData?.year) {
                    await dispatch(secondarySearch(vehicleData.year)).then(response => {
                        const vehiclesMakes = response.payload;

                        if (vehicleData?.make !== null || vehicleData?.make !== " " || vehicleData?.make !== undefined) {

                            dispatch(searchMake([vehicleData?.year, getKeyByValue(vehiclesMakes?.vehicles, vehicleData?.make)])).then(response => {
                                response.payload && dispatch(fetchTrimData(vehicleData?.modelCode))
                            });
                        }
                    });
                }
                setButtonClicked(false);
            }
        }

        dispatchActions();
    }, [buttonClicked]);

    useEffect(() => {
        if (trimCodes && trimCodes.length > 0 && trimCodes[0]) {
            const [newCode, ...newTrimCodes] = trimCodes;
            const definedTrimCodes = newTrimCodes.filter((code) => code !== undefined);
            const trimCodesStr = definedTrimCodes.join('-');
            const urlParts = window.location.pathname.split('/');
            const featuresIndex = urlParts.indexOf('photos');

            if (featuresIndex !== -1 && featuresIndex < urlParts.length - 1) {
                const code = urlParts[featuresIndex + 1];
                const codes = urlParts.slice(featuresIndex + 2).join('-');
                const isCodeChanged = code !== newCode;
                const isCodesChanged = codes !== trimCodesStr;

                if (isCodeChanged || isCodesChanged) {
                    const updatedCodes = [];
                    if (newCode) updatedCodes.push(newCode);
                    if (trimCodesStr) updatedCodes.push(trimCodesStr);
                    let finalCodesStr = updatedCodes.join('/');
                    finalCodesStr = finalCodesStr.replace(/^-/, '');
                    finalCodesStr = finalCodesStr.replace(/-$/, '');
                    const finalUrl = urlParts.slice(0, featuresIndex + 1).join('/') + `/${finalCodesStr}/`;
                    window.history.replaceState(null, null, finalUrl);
                }
            }
        }
    }, [trimCodes]);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY < 10;
            setScroll(scrollCheck);
            setIsTop(scrollCheck);
        });
    });
    const timer = React.useRef();
    useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    const handleImageLoad = () => {
        setLoading(false);
    };

    const handleToggleMenu =() => {
        setShowNav(!showNav)
        setChecked(true)
    }

    function getVehicleImage(vehicle, vehicleType) {
        let filteredVehicle = vehicle.filter((profileView) => profileView.code === profile && profileView.imageType === viewAngle && profileView.url !== '');
        const imageNotAvailable = filteredVehicle[0]?.url.includes("image_not_available");

        if (filteredVehicle.length !== 0) {
            return (
                <Carousel.Item data-testid ={vehicle}>
                    <div className="competitor-img-competitor">
                        <img src={filteredVehicle[0].url} className={'competitor-img-responsive'}
                             alt={filteredVehicle[0].url}
                             onLoad={handleImageLoad}
                             style={{display: loading ? 'none' : 'block'}}/>
                    </div>
                    {!isMobile &&
                    <div className="powertrain-icon" style={{bottom: imageNotAvailable && '20px'}}>
                        <PowerTrainType powertrain={vehicleType?.powertrain}
                        />
                    </div>
                    }

                </Carousel.Item>
            )
        } else {
            return (
                <Carousel.Item>
                    <div className="competitor-img-competitor">
                        <img src={comingSoonIMG} className={'competitor-img-responsive'} alt={comingSoonIMG}/>
                    </div>
                </Carousel.Item>
            )
        }
    }

    function selectSliderImage(index) {
        const mediaCode = index;
        dispatch(setVehicleCode(mediaCode))
        if (getCompareImages && getCompareImages[0]?.media ) {
            const mediaImage = getCompareImages[0].media[Object.keys(getCompareImages[0].media)[0]];
            if (mediaImage && Object.values(mediaImage).length > 0) {
                const currentAngleShot = Object.values(mediaImage)[mediaCode];
                if (currentAngleShot) {
                    dispatch(setImageTypeView(currentAngleShot.imageType));
                    dispatch(setProfileView(currentAngleShot.code));
                }
            }
        }
    }

    function filterArrayView(imageType) {
        dispatch(setImageType(imageType.toUpperCase()))
    }

    const getCarouselImage = (media, activeLocale) => {
        let mediaToShow = comingSoonIMG;
        if (activeLocale === 'fr-CA') {
            mediaToShow = comingSoonIMG_fr;
        } else if (activeLocale === 'es-US') {
            mediaToShow = comingSoonIMG_es;
        }
        return media ? media : mediaToShow;
    }

    const buildCarousel = (media) => {
        return (
            <Carousel.Item key={media?.url} >
                <div className={'photo-section'} data-testid ={media?.imageType}>
                    <div className="primary-carousel-container">
                       <div className="compare-slider-photo-container">
                           <img src={getCarouselImage(media && media?.url,activeLocale)} className={'compare-slider-photo'} alt={media.url}/>
                       </div>
                        {!isMobile &&
                    <div className="powertrain-icon primary-powertrain-icon">
                        <PowerTrainType powertrain={getCompareImages[0]?.powertrain}/>
                    </div>
                        }
                    </div>
                </div>
            </Carousel.Item>
        )
    }

    function showSecondaryVehicles(length,vehicle,id) {
        return(
            <div className={'secondaryVehicle'}>
                 <button
                    type="button"
                    className={"close-compare"}
                    id={"photos-vehicle-remove"}
                    onClick={() => removeVehicle(vehicle, id)}
                    disabled={checkLockStatus(vehicle, isLocked, id)}
                    title={checkLockStatus(vehicle, isLocked,id)? t("overview.changeSelectModal.vehicleLocked") : null}
                >
                    <CloseIcon fontSize={"medium"}/>
                </button>
                <div className={'competitor-image'}>
                    <Carousel indicators={false}
                              interval={null}
                              controls={false}
                              slide={false}>

                        {
                            vehicle && vehicle.media && getVehicleImage((Object.values(vehicle.media[Object.keys(vehicle.media)[0]])))
                        }
                    </Carousel>
                </div>
                <div className={'competitor-details'}>
                    <div className={'competitor-title'}>
                        {
                            getVehicleDetails(vehicle)
                        }
                    </div>
                    {vehicle && <div className={'competitor-price'}>
                        {t('overview.startingFrom')} {""}
                        {currencyConverter(vehicle?.pricing.msrp,activeLocale)}
                    </div>}
                    <div className={'change-section'}>
                        <div className={'color-container'}>
                            <Color primaryColor={vehicle?.colors?.exteriors}
                                   translate={t}
                                   mediaColor={vehicle?.currentColor}
                                   interiorColor={vehicle?.colors?.interiors}/>

                            <button id={id}
                                    className={'btn-default enlarge-btn-secondary'}
                                    onClick={(event) => secondaryEnlargeView(id, vehicle)}>

                                    <span className="photos-enlarge-button">
                                      <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter}/>
                                    </span>
                            </button>
                        </div>

                        <div className={'change-container'}>
                            <button
                                id={id}
                                className={checkLockStatus(vehicle, isLocked, id) ? `btn-default ${headerLoadType ? "jdpa-button-disabled" : "btn-change-disabled"}` : "btn-default btn-change-compare"}
                                value={vehicle}
                                onClick={(event) => changeHandler(id, vehicle)}
                                disabled={isLocked && isLocked[id]}
                            >
                                {vehicle ?
                                    t('overview.changeSelectModal.change') :
                                    t('overview.controls.selectVehicle')
                                }
                            </button>

                            <Change
                                vehicleData={vehicleData}
                                setVehicleData={setVehicleData}
                                openModal={openModal}
                                setOpenModal={setOpenModal}
                                handleModalClose={handleModalClose}
                                years={secondaryYear}
                                vehicleMake={vehiclesMakes}
                                vehicleModels={vehicleModel}
                                trimModel={trimModel}
                                setTrimModel={setTrimModel}
                                setVehicleModel={setVehicleModel}
                                setVehicleMake={setVehicleMake}
                                vehiclesTrim={vehiclesTrim}
                                vehicleIndex={vehicleIndex}
                                vehicleTypeName={vehicleTypeName}
                                driveType={driveType}
                                setDriveType={setDriveType}
                                lockedVehicle={isLocked}
                            />
                            <LockCompetitor isLocked={isLocked}
                                            vehicle={vehicle}
                                            vehicleIndex={id}
                                            trimCodes={trimCodes}
                                            toggleLock={() => handleToggle(id, vehicle)}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const showChangeSelector = () => {
        return (
            <React.Fragment>

            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <MediaQuery minWidth={1200}>
                <Navbar
                    setIsTop={setIsTop}
                    scroll={scroll}
                    setScroll={setScroll}
                    isTop={isTop}
                    leftChildren={(
                        <React.Fragment>
                            <button className={'btn-compare feature-not-active'} onClick={() => navigateFeatures()}>
                                {t('navigation.features')}
                            </button>

                            <button className={'btn-compare feature-active'}>
                                {t('navigation.photos')}
                            </button>
                        </React.Fragment>
                    )}
                    rightChildren=
                        {headerLoadType != null ? (
                            <NavbarBtn />
                        ) : (
                            <NavbarBtn compareTrim={vehicle} />
                        )}
                    isMobile={isMobile}

                />
            </MediaQuery>
            <MediaQuery maxWidth={1199}>
                <Navbar
                    leftChildren={
                        <React.Fragment>
                            {
                                showMobileNav(navigateFeatures, vehicle, t, pathname, showNav, checked, handleToggleMenu, headerLoadType)
                            }
                        </React.Fragment>
                    }
                    rightChildren={
                        <React.Fragment>
                            <NavbarBtn
                                compareTrim={vehicle}
                                singularButton={headerLoadType !== null}/>
                        </React.Fragment>
                    }
                    isMobile={isMobile}
                />
            </MediaQuery>
            {isLoaded ? (
                <Loader/>) : (
                <>
                    {
                        <React.Fragment> {getCompareImages && getCompareImages[0] && <>
                            <div className={'panel-photo'}>
                                <div className={'primary-vehicle-container'}>
                                    {/*Following code block will show  Primary Vehicle's Carousel*/}
                                    <PrimaryVehicle
                                        props={props}
                                        vehicleCode={vehicleCode}
                                        buildCarousel={buildCarousel}
                                        getCompareImages={getCompareImages}
                                        selectSliderImage={selectSliderImage}
                                    />
                                    {/*Following code block will show only Primary Vehicle's detail for screen width 900 and more*/}
                                    <VehicleDetailsLargeScreen
                                        getCompareImages={getCompareImages}
                                        activeLocale={activeLocale}
                                    />
                                </div>
                                {/*Following code block will show only Primary Vehicle's detail for screen width 320 to 899*/}
                                <PrimaryVehicleDetails
                                    getCompareImages={getCompareImages}
                                    vehicleCode={vehicleCode}
                                    changeHandler={changeHandler}
                                    isLocked={isLocked}
                                    trackGalleryScrollRight={trackGalleryScrollRight}
                                    trackGalleryScrollLeft={trackGalleryScrollLeft}
                                    vehicleData={vehicleData}
                                    setVehicleData={setVehicleData}
                                    openModal={openModal}
                                    handleModalClose={handleModalClose}
                                    secondaryYear={secondaryYear}
                                    vehiclesMakes={vehiclesMakes}
                                    vehicleModel={vehicleModel}
                                    trimModel={trimModel}
                                    setTrimModel={setTrimModel}
                                    setVehicleModel={setVehicleModel}
                                    vehiclesTrim={vehiclesTrim}
                                    vehicleIndex={vehicleIndex}
                                    vehicleTypeName={vehicleTypeName}
                                    driveType={driveType}
                                    setDriveType={setDriveType}
                                    handleToggle={handleToggle}
                                    setPrimaryAndSecondaryVehicles={setPrimaryAndSecondaryVehicles}
                                    viewAngle={viewAngle}
                                    setIsButtonClicked={setIsButtonClicked}
                                    filterArrayView={filterArrayView}
                                    trackExteriorFilterButton={trackExteriorFilterButton}
                                    trackInteriorFilterButton={trackInteriorFilterButton}
                                    handleOpen={handleOpen}
                                    enlargeView={enlargeView}
                                    compareGroup={compareGroup}
                                    showChangeSelector={showChangeSelector}
                                    activeLocale={activeLocale}
                                    headerLoadType={headerLoadType}
                                />

                                {/*Following code block will show Color, Exterior, Interior, gallery view and Enlarge button for Primary Vehicle for screen min width 900px*/}
                                <MediaQuery minWidth={'900px'}>
                                    <div className={'photo-change-section'}>
                                        <PhotoViewFilter
                                            getCompareImages={getCompareImages}
                                            t={t}
                                            viewAngle={viewAngle}
                                            filterArrayView={filterArrayView}
                                            setIsButtonClicked={setIsButtonClicked}
                                            trackExteriorFilterButton={trackExteriorFilterButton}
                                            compareGroup={compareGroup}
                                            setIsAngleChanged={setIsAngleChanged}
                                            trackInteriorFilterButton={trackInteriorFilterButton}
                                            handleOpen={handleOpen}
                                        />
                                        <PrimaryVehicleEnlarge
                                            enlargeView={enlargeView}
                                            t={t}
                                        />
                                        {headerLoadType != null && (
                                            <div className={"vehicle-CTA primary-CTA"}>
                                                <a target="_blank" href={vehicleCTA}>See Cars For Sale</a>
                                            </div>
                                        )}
                                        <PrimaryVehicleToolbar
                                            getCompareImages={getCompareImages}
                                            vehicleData={vehicleData}
                                            setVehicleData={setVehicleData}
                                            openModal={openModal}
                                            handleModalClose={handleModalClose}
                                            secondaryYear={secondaryYear}
                                            vehiclesMakes={vehiclesMakes}
                                            vehicleModel={vehicleModel}
                                            trimModel={trimModel}
                                            setTrimModel={setTrimModel}
                                            setVehicleModel={setVehicleModel}
                                            setVehicleMake={setVehicleMake}
                                            vehiclesTrim={vehiclesTrim}
                                            vehicleIndex={vehicleIndex}
                                            t={t}
                                            vehicleTypeName={vehicleTypeName}
                                            driveType={driveType}
                                            setDriveType={setDriveType}
                                            isLocked={isLocked}
                                            changeHandler={changeHandler}
                                            activeLocale={activeLocale}
                                        />
                                    </div>
                                </MediaQuery>
                            </div>
                            <MediaQuery minWidth={'320px'} maxWidth={'899px'}>
                                    <SecondaryVehicleCarousel
                                        vehicle={getCompareImages[1]}
                                        isAngleChanged={isAngleChanged}
                                        profile={profile}
                                        isPrimaryImageCarousel = {isPrimaryImageCarousel}
                                        getCompareImages={getCompareImages}
                                        setOpenModal={setOpenModal}
                                        handleModalClose={handleModalClose}
                                        vehicleData={vehicleData}
                                        setVehicleData={setVehicleData}
                                        openModal={openModal}
                                        secondaryYear={secondaryYear}
                                        vehiclesMakes={vehiclesMakes}
                                        vehicleModel={vehicleModel}
                                        trimModel={trimModel}
                                        setTrimModel={setTrimModel}
                                        setVehicleModel={setVehicleModel}
                                        setVehicleMake={setVehicleMake}
                                        vehiclesTrim={vehiclesTrim}
                                        vehicleIndex={1}
                                        vehicleTypeName={vehicleTypeName}
                                        driveType={driveType}
                                        setDriveType={setDriveType}
                                        isLocked={isLocked}
                                        changeHandler={changeHandler}
                                        removeVehicle={removeVehicle}
                                        t={t}
                                        vehicleCode={vehicleCode}
                                        secondaryCarouselIndex={secondaryCarouselIndex}
                                        trackGalleryScrollRight={trackGalleryScrollRight}
                                        trackGalleryScrollLeft={trackGalleryScrollLeft}
                                        trackExteriorFilterButton={trackExteriorFilterButton}
                                        trackInteriorFilterButton={trackInteriorFilterButton}
                                        handleOpen={handleOpen}
                                        enlargeView={enlargeView}
                                        viewAngle={viewAngle}
                                        compareGroup={compareGroup}
                                        activeLocale={activeLocale}
                                        getVehicleImage={getVehicleImage}
                                        isMobile={isMobile}
                                        isMobileHeight={isMobileHeight}
                                        swapTriggered = {swapTriggered}
                                        handleToggle={handleToggle}
                                        headerLoadType={headerLoadType}
                                    />
                            </MediaQuery>

                            <MediaQuery minWidth={'320px'} maxWidth={'899px'}>
                                <div className={'secondary-container'}>

                                    {getCompareImages.slice(2,4).map((vehicle, index) => {
                                        return (

                                                <SecondaryCompetitors
                                                    id={index+2}
                                                    vehicle={vehicle}
                                                    getVehicleImage={getVehicleImage}
                                                    secondaryEnlargeView={secondaryEnlargeView}
                                                    setOpenModal={setOpenModal}
                                                    handleModalClose={handleModalClose}
                                                    vehicleData={vehicleData}
                                                    setVehicleData={setVehicleData}
                                                    openModal={openModal}
                                                    secondaryYear={secondaryYear}
                                                    vehiclesMakes={vehiclesMakes}
                                                    vehicleModel={vehicleModel}
                                                    trimModel={trimModel}
                                                    setTrimModel={setTrimModel}
                                                    setVehicleModel={setVehicleModel}
                                                    setVehicleMake={setVehicleMake}
                                                    vehiclesTrim={vehiclesTrim}
                                                    vehicleIndex={vehicleIndex}
                                                    vehicleTypeName={vehicleTypeName}
                                                    driveType={driveType}
                                                    setDriveType={setDriveType}
                                                    isLocked={isLocked}
                                                    changeHandler={changeHandler}
                                                    removeVehicle={removeVehicle}
                                                    activeLocale={activeLocale}
                                                    t={t}
                                                    dispatch={dispatch}
                                                    isMobile={isMobile}
                                                    isMobileHeight = {isMobileHeight}
                                                    isLoading={loadingStates}
                                                    handleClick={handleClick}
                                                    handleToggle={handleToggle}
                                                    headerLoadType={headerLoadType}
                                                />

                                        );
                                    })}

                                    {getCompareImages && getCompareImages.length < 4 && <BuildMissingCompetitor
                                        t={t}
                                        vehicleData={vehicleData}
                                        setVehicleData={setVehicleData}
                                        openModal={openModal}
                                        setOpenModal={setOpenModal}
                                        secondaryYear={secondaryYear}
                                        vehiclesMakes={vehicleMake}
                                        vehicleModel={vehicleModel}
                                        trimModel={trimModel}
                                        setTrimModel={setTrimModel}
                                        vehiclesTrim={vehiclesTrim}
                                        vehicleIndex={vehicleIndex}
                                        vehicleTypeName={vehicleTypeName}
                                        driveType={driveType}
                                        setDriveType={setDriveType}
                                        setVehicleModel={setVehicleModel}
                                        setVehicleMake={setVehicleMake}
                                        isLocked={isLocked}
                                        handleOpen={handleOpen}
                                        getCompareImages={getCompareImages}
                                        handleModalClose={handleChangeModalClose}
                                        changeHandler={changeHandler}
                                        headerLoadType={headerLoadType}
                                        maxSmallScreenWidth = {maxSmallScreenWidth}
                                    />}

                                </div>

                            </MediaQuery>

                            <MediaQuery minWidth={'900px'}>
                                <div className={'secondary-container'}>
                                    {getCompareImages && getCompareImages.slice(1).map((vehicle, index) => (
                                            <SecondaryCompetitors
                                                id={index+1}
                                                vehicle={vehicle}
                                                getVehicleImage={getVehicleImage}
                                                showSecondaryVehicles={showSecondaryVehicles}
                                                secondaryEnlargeView={secondaryEnlargeView}
                                                handleModalClose={handleModalClose}
                                                vehicleData={vehicleData}
                                                setOpenModal={setOpenModal}
                                                setVehicleData={setVehicleData}
                                                openModal={openModal}
                                                secondaryYear={secondaryYear}
                                                vehiclesMakes={vehiclesMakes}
                                                vehicleModel={vehicleModel}
                                                trimModel={trimModel}
                                                setTrimModel={setTrimModel}
                                                setVehicleModel={setVehicleModel}
                                                setVehicleMake={setVehicleMake}
                                                vehiclesTrim={vehiclesTrim}
                                                vehicleIndex={vehicleIndex}
                                                vehicleTypeName={vehicleTypeName}
                                                driveType={driveType}
                                                setDriveType={setDriveType}
                                                isLocked={isLocked}
                                                changeHandler={changeHandler}
                                                removeVehicle={removeVehicle}
                                                handleToggle={handleToggle}
                                                activeLocale={activeLocale}
                                                t={t}
                                                dispatch={dispatch}
                                                isMobile = {false}
                                                headerLoadType={headerLoadType}
                                            />

                                    ))}

                                        {getCompareImages?.length && getCompareImages?.length < 4 && <BuildMissingCompetitor
                                            t={t}
                                            vehicleData={vehicleData}
                                            setVehicleData={setVehicleData}
                                            openModal={openModal}
                                            setOpenModal={setOpenModal}
                                            secondaryYear={secondaryYear}
                                            vehiclesMakes={vehicleMake}
                                            vehicleModel={vehicleModel}
                                            trimModel={trimModel}
                                            setTrimModel={setTrimModel}
                                            setVehicleMake={setVehicleMake}
                                            vehiclesTrim={vehiclesTrim}
                                            vehicleIndex={vehicleIndex}
                                            vehicleTypeName={vehicleTypeName}
                                            driveType={driveType}
                                            setDriveType={setDriveType}
                                            setVehicleModel={setVehicleModel}
                                            isLocked={isLocked}
                                            handleOpen={handleOpen}
                                            getCompareImages={getCompareImages}
                                            handleModalClose={handleChangeModalClose}
                                            changeHandler={changeHandler}
                                            headerLoadType={headerLoadType}
                                        />}
                                    </div>

                            </MediaQuery>
                        </>
                        }
                        </React.Fragment>
                    }
                    <Modal
                        open={open}
                        onClose={handleClose}
                        disableScrollLock={false}>
                        <div className="available-view-container">
                            <div className={'overViewContainer'}>
                                <div className={'photo-panel-title'}>{t('photo.thumbnail.modalHeader')}
                                    <button
                                        type="button"
                                        className={"close-compare"}
                                        onClick={() => handleClose()}
                                    >
                                        <CloseIcon fontSize={"medium"}/></button>
                                </div>
                                <div className="image-thumbnail-container">
                                    {
                                        getCompareImages && getCompareImages[0]?.media &&
                                        (Object.values(getCompareImages[0].media[Object.keys(getCompareImages[0].media)[0]])).map((media, index) =>
                                            <div className={'available-image-tiles'} key={media.url}>
                                                <img src={getCarouselImage(media && media?.url, activeLocale)}
                                                     className={'image-tile'} alt={media.url} onClick={() => {
                                                    selectSliderImage(index)
                                                    dispatch(setVehicleCode(index))
                                                    dispatch(setVehicleIndex(index))
                                                    dispatch(setIsAngleChanged(true));
                                                    handleClose()
                                                    trackGalleryViewSelected(compareGroup)
                                                }}/>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>

                    </Modal>

                    <Modal
                        open={openEnlarge}
                        onClose={handleClose}
                        disableScrollLock={false}>
                        <div className={'enlargeOverViewContainer'}>
                            <div className={'model-header-title'}>
                                <button
                                    type="button"
                                    className={"close-compare"}
                                    onClick={() => handleClose()}>
                                    <CloseIcon fontSize={"medium"}/>
                                </button>
                                <div className={'panel-title'}>
                                    {getCompareImages && getCompareImages[0]?.description}
                                </div>
                            </div>
                            <div className={'photo-panel-title'}/>
                            <Carousel
                                indicators={false}
                                interval={null}
                                variant={"dark"}
                                onSelect={(eventKey) => {
                                    dispatch(setVehicleIndex(eventKey))
                                }
                                }
                                activeIndex={secondaryVehicleIndex}
                            >
                                {
                                    getCompareImages && getCompareImages[0]?.media && (Object.values(getCompareImages[0].media[Object.keys(getCompareImages[0].media)[0]]))
                                        .map(media =>
                                            <Carousel.Item>
                                                <div className="primaryImageContainer">
                                                    <img src={getCarouselImage(media && media?.url, activeLocale)}
                                                         alt={media.url}
                                                         className={'enlargeImages'}
                                                         key={media.url}/>
                                                </div>
                                            </Carousel.Item>)
                                }</Carousel>

                            {<div className={'carousel-count'}> image
                                of {secondaryVehicleIndex + 1} to {getCompareImages && getCompareImages[0]?.media
                                && (Object.values(getCompareImages[0].media[Object.keys(getCompareImages[0].media)[0]])).length}
                            </div>}
                        </div>

                    </Modal>

                    <Modal open={secondaryLarge}
                           onClose={handleClose}
                           disableScrollLock={false}>
                        <div className={'enlargeOverViewContainer'}>
                            <div className={'model-header-title'}>
                                <div className={'panel-title'}>
                                    {vehicleDescription}
                                </div>
                                <button
                                    type="button"
                                    className={"close-compare"}
                                    onClick={() => handleClose()}>
                                    <CloseIcon fontSize={"medium"}/>
                                </button>
                            </div>
                            <div className={'photo-panel-title'}/>
                            <Carousel
                                indicators={false}
                                interval={null}
                                variant={"dark"}
                                onSelect={(eventKey) => {
                                    dispatch(setCarouselIndex(eventKey));
                                }}
                                activeIndex={secondaryIndex}
                            >
                                {activeButton &&
                                getCompareImages &&
                                getCompareImages[activeButton] &&
                                getCompareImages[activeButton].media &&
                                Object.values(getCompareImages[activeButton].media[Object.keys(getCompareImages[activeButton].media)[0]])
                                    .map(media => (
                                        <Carousel.Item key={media.url}>
                                            <div className="secondaryImageContainer">
                                                <img
                                                    src={media?.url ? media?.url : comingSoonIMG}
                                                    alt={media.code}
                                                    className={'enlargeImages'}
                                                />
                                            </div>
                                        </Carousel.Item>
                                    ))}
                            </Carousel>


                            {activeButton && getCompareImages && getCompareImages[activeButton] && getCompareImages[activeButton].media && getCompareImages[activeButton].media[Object.keys(getCompareImages[0].media)[0]] && (
                                <div className={'carousel-count'}>
                                    image of {secondaryIndex + 1} to {Object.values(getCompareImages[activeButton].media[Object.keys(getCompareImages[0].media)[0]]).length}
                                </div>
                            )}
                        </div>
                    </Modal>
                </>
            )
            }
        </React.Fragment>
    )
}

export default Photos;